// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibCardList_old-container__GXXm7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibCardList_old-container__GXXm7.nibCardList_wrap__KMsbw {
  flex-wrap: wrap;
}
.nibCardList_old-container__GXXm7 .nibCardList_box__P1fyG.nibCardList_col__Sfy\\+e {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibCardList_old-container__GXXm7 .nibCardList_box__P1fyG.nibCardList_col__Sfy\\+e > div {
  width: 100%;
}
.nibCardList_old-container__GXXm7 .nibCardList_box__P1fyG.nibCardList_row__klEUp {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibCardList_old-container__GXXm7 form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibCardList_old-container__GXXm7 form > .nibCardList_box__P1fyG.nibCardList_col__Sfy\\+e {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibCardList_old-container__GXXm7 form > .nibCardList_box__P1fyG.nibCardList_col__Sfy\\+e {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibCardList_old-container__GXXm7, .nibCardList_col__Sfy\\+e, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibCardList_old-container__GXXm7, .nibCardList_col__Sfy\\+e, form {
    padding: 0px;
  }
}
.nibCardList_text-overflow-hidden__uhc2l {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibCardList_icon__38AVz {
  color: var(--accent-color);
}

.nibCardList_richtext-output-wrap__hBPjA .nibCardList_se-video-container__\\+sen6 figure {
  padding-bottom: 0 !important;
}

.nibCardList_list__MR7dK {
  background-color: #212121;
  box-shadow: -5px 5px 10px 0px rgba(0, 0, 0, 0.35);
}

.nibCardList_labels__-Egfc {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
}
.nibCardList_labels__-Egfc p {
  color: #fff;
}

.nibCardList_inner__WFPRW {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.nibCardList_inner__WFPRW .nibCardList_label__kcCkT {
  flex-basis: 50%;
  color: #fff;
}
.nibCardList_inner__WFPRW .nibCardList_checkBox__oWMm4 {
  flex-basis: 25%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibCard/NibCardList/nibCardList.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,yBDyB8B;EApBhC,iDAAA;ACwEF;;AA1EA;EDJE,aAAA;EACA,mBCIQ;EDHR,8BCGa;EDFb,mBCE4B;EAC1B,iBAAA;AAgFJ;AA/EI;EACI,WAAA;AAiFR;;AA/EA;EACI,WAAA;EDXF,aAAA;EACA,mBCWQ;EDVR,2BCUa;EDTb,mBCSyB;AAqF3B;AApFI;EACI,eAAA;EACA,WAAA;AAsFR;AArFI;EACI,eAAA;EDjBN,aAAA;EACA,mBCiBY;EDhBZ,yBCgBiB;EDfjB,mBCe2B;AA0F7B","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../../sass/settings'\n\n.list\n    background-color: $container_item_background_color\n    +shadow()\n\n.labels\n    +flex(row, space-between, center)\n    padding: 5px 15px\n    p\n        color: #fff\n\n.inner\n    width: 100%\n    +flex(row, flex-start, center)\n    .label\n        flex-basis: 50%\n        color: #fff\n    .checkBox\n        flex-basis: 25%\n        +flex(row, flex-end, center)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibCardList_old-container__GXXm7`,
	"wrap": `nibCardList_wrap__KMsbw`,
	"box": `nibCardList_box__P1fyG`,
	"col": `nibCardList_col__Sfy+e`,
	"row": `nibCardList_row__klEUp`,
	"text-overflow-hidden": `nibCardList_text-overflow-hidden__uhc2l`,
	"icon": `nibCardList_icon__38AVz`,
	"richtext-output-wrap": `nibCardList_richtext-output-wrap__hBPjA`,
	"se-video-container": `nibCardList_se-video-container__+sen6`,
	"list": `nibCardList_list__MR7dK`,
	"labels": `nibCardList_labels__-Egfc`,
	"inner": `nibCardList_inner__WFPRW`,
	"label": `nibCardList_label__kcCkT`,
	"checkBox": `nibCardList_checkBox__oWMm4`
};
export default ___CSS_LOADER_EXPORT___;
